(function () {
  if (!window.jQuery) return;
  var $ = window.jQuery;

  $(document).on('click', '.product-with-dot-slides-inner-row .slider-button', function () {
    var active_dot = $(this).parents('slider-component').find('.slider-counter--dots .slider-counter__link--active');
    var dots = $(this).parents('slider-component').find('.slider-counter--dots .slider-counter__link--dots');

    if ($(this).hasClass('slider-button--prev')) {
      if ($(active_dot).prev().length == 0) {
        $($(dots)[$(dots).length - 1]).click();
      }
    } else {
      if ($(active_dot).next().length == 0) {
        $($(dots)[0]).click();
      }
    }
  });

  $(document).ready(function () {
    $('.product-grid-container').addClass('active');
  });
})();
